import { network } from 'services/network';

import { QueryParams } from 'api/mutations/deleteRiskRegister.mutate';

export const deleteRiskRegister = ({ riskId }: QueryParams) => {
    const url = `api/bo/deleteRiskRegister`;
    return network.post(url, riskId).then((response) => response.data);
};
